module.exports = __webpack_public_path__ + "images/emoji/tractor.b2ca413ed970bf5b9a3e.png";